import React from "react";
import { ArrowRight, Globe, Database, Shield, Users } from "lucide-react";
import { Button } from "./ui/button";

const SERVICES = [
    {
        icon: Globe,
        title: "PENGEMBANGAN WEB",
        description:
            "Menyediakan layanan IT strategis untuk memenuhi kebutuhan transformasi Anda, solusi profesional untuk menyelesaikan proyek dengan cepat dan aman.",
    },
    {
        icon: Database,
        title: "SISTEM CLOUD",
        description:
            "Arsitektur cloud yang dapat diskalakan dirancang untuk performa tinggi dan keamanan maksimal di semua region.",
    },
    {
        icon: Shield,
        title: "PERLINDUNGAN CYBER",
        description:
            "Audit keamanan komprehensif dan pemantauan 24/7 untuk menjaga data perusahaan Anda tetap aman dari ancaman.",
    },
    {
        icon: Users,
        title: "KONSULTASI IT",
        description:
            "Layanan konsultasi ahli untuk menyelaraskan roadmap teknologi Anda dengan tujuan bisnis secara efisien.",
    },
];

export default function UnmatchedServices() {
    return (
        <section className="py-24 bg-[#020617] text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-3 gap-16">
                    {/* Header Section */}
                    <div className="lg:col-span-1">
                        <h2 className="text-4xl md:text-5xl font-display font-bold leading-tight mb-8">
                            Layanan
                            <br />
                            Terbaik.
                            <br />
                            Keunggulan
                            <br />
                            Terdepan.
                        </h2>
                        <Button
                            variant="outline"
                            size="icon"
                            className="rounded-full w-12 h-12 border-gray-700 hover:bg-white hover:text-black transition-colors"
                        >
                            <ArrowRight className="w-5 h-5" />
                        </Button>
                    </div>

                    {/* Services Grid */}
                    <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
                        {SERVICES.map((service, index) => (
                            <div
                                key={index}
                                className="p-8 rounded-2xl border border-gray-800 hover:border-blue-600 transition-colors group bg-transparent"
                            >
                                <service.icon className="w-8 h-8 text-blue-500 mb-6 group-hover:scale-110 transition-transform" />
                                <h3 className="text-sm font-bold tracking-wider uppercase mb-3">
                                    {service.title}
                                </h3>
                                <p className="text-gray-400 text-sm leading-relaxed">
                                    {service.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
